import React, { useEffect, useState } from 'react';
import ApiGrid from '@components-clean/core/api-grid';
import { ApiGridParams } from '@interfaces/central-monitoring';
import { ChipHeaders, MonitoringToolKitTables, ObservationType } from '@interfaces-clean/observations.interface';
import { useLocalState } from '@hooks/index';

const ChipGrid = () => {
    const { state: localState } = useLocalState();
    const studyRef = localState?.selectedStudy?.id as string;
    const [updateGridParams, setGridParams] = useState<ApiGridParams>({
        grid: 'Observations',
        studyRef,
        level: ObservationType.Study,
        observationId: null,
    });
    const [selectedChipHeader, setSelectedChipHeader] = useState<number>(1);
    const headers = [
        { id: ChipHeaders.ObservationsView, label: 'Observations' },
        { id: ChipHeaders.ReviewLogView, label: 'ReviewLogs' },
        { id: ChipHeaders.ActionView, label: 'Actions' },
    ];

    const onChipSelected = (chipHeader: number): void => {
        switch (chipHeader) {
            case 1:
                setSelectedChipHeader(1);
                setGridParams((prevState) => ({
                    ...prevState,
                    grid: 'Observations',
                    level: ObservationType.Study,
                    observationId: null,
                }));
                break;

            case 2:
                setSelectedChipHeader(2);
                setGridParams((prevState) => ({
                    ...prevState,
                    grid: 'ReviewLog',
                    level: ObservationType.Study,
                    observationId: null,
                }));
                break;

            case 3:
                setSelectedChipHeader(3);
                setGridParams((prevState) => ({
                    ...prevState,
                    grid: 'Actions',
                    level: ObservationType.Study,
                    observationId: null,
                }));
                break;

            default:
                setSelectedChipHeader(1);
                setGridParams((prevState) => ({
                    ...prevState,
                    grid: 'Observations',
                    level: ObservationType.Study,
                    observationId: null,
                }));
        }
    };

    useEffect(() => {
        setGridParams((prevState) => ({
            ...prevState,
            studyRef,
        }));
    }, [studyRef]);

    return (
        <ApiGrid
            title={headers}
            gridParams={updateGridParams}
            table={MonitoringToolKitTables.Observations}
            maxHeight="calc(100vh - 230px)"
            testDataId="dummy-components-chip-grid"
            onChipHeaderSelected={onChipSelected}
            selectedChipHeader={selectedChipHeader}
        />
    );
};

export default ChipGrid;
